"use client";

import type { FormHTMLAttributes, ReactNode, Ref, FormEvent } from "react";
import {
  InpSafeFormContext,
  mergeRefs,
  useInpSafeForm,
} from "@/helpers/inpSafeForm";

type InpSafeFormProps = Omit<FormHTMLAttributes<HTMLFormElement>, "onSubmit"> & {
  onSubmit: (e?: FormEvent) => void | Promise<void>;
  children: ReactNode;
  formRef?: Ref<HTMLFormElement>;
};

/**
 * Drop-in <form> replacement — blocks native submit (GTM onsubmit INP) while
 * preserving Enter-key submit and SubmitButton integration.
 */
export default function InpSafeForm({
  onSubmit,
  children,
  formRef,
  ...rest
}: InpSafeFormProps) {
  const inpSafe = useInpSafeForm(onSubmit);

  return (
    <InpSafeFormContext.Provider value={inpSafe.runSubmit}>
      <form
        {...inpSafe.formProps}
        {...rest}
        ref={mergeRefs(formRef, inpSafe.formRef)}
      >
        {children}
      </form>
    </InpSafeFormContext.Provider>
  );
}
